// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__ICRAK","headers":"Table_headers__gukK0","selected":"Table_selected__K4ufB","body":"Table_body__jr7br","badge":"Table_badge__cGTV0"};